module.exports = __webpack_public_path__ + "img/13b-doc-emissao-info.0461cf6c.png";